import * as React from 'react';
import { QuestionTypesMap } from '@nexxt/common/questionTypes';
import { getRichTextFromQuestionTexts } from '../../../../../../utils/question';
import { QTYPES, QuestionSummary, ProjectLanguage } from '@nexxt/common/types';
import RichTextTranslation from '../../../../../common/richTextField/Readonly';

interface IShowQuesitonProps {
    questionSummaries: QuestionSummary[];
    languages: ProjectLanguage[];
}

const ShowQuestion: React.SFC<IShowQuesitonProps> = ({
    questionSummaries,
    languages
}: IShowQuesitonProps) => (
    <div>
        {questionSummaries.map((questionSummary, index) => {
            if (
                questionSummary.type === QTYPES.GROUP ||
                questionSummary.type === QTYPES.POPUP
            ) {
                return (
                    <ShowGroupQuestion
                        key={questionSummary.id}
                        questionSummary={questionSummary}
                        languages={languages}
                    />
                );
            } else {
                return (
                    <ShowSingleQuestion
                        key={questionSummary.id}
                        questionSummary={questionSummary}
                        languages={languages}
                    />
                );
            }
        })}
    </div>
);

export default ShowQuestion;

interface ShowSingleQuestionProps {
    questionSummary: QuestionSummary;
    languages: ProjectLanguage[];
}

interface ShowGroupQuestionProps {
    questionSummary: QuestionSummary;
    languages: ProjectLanguage[];
}

const ShowSingleQuestion: React.SFC<ShowSingleQuestionProps> = ({
    questionSummary,
    languages
}: ShowSingleQuestionProps) => (
    <div className="option-box question-card ">
        <div className="q-card-header">
            {questionSummary.type !== QTYPES.POPUP_CARD && (
                <span className="question-image">
                    <img
                        src={
                            (
                                QuestionTypesMap[questionSummary.type] ||
                                QuestionTypesMap[QTYPES.SINGLE_CHOICE]
                            ).image
                        }
                    />
                </span>
            )}
            <span className="badge badge--blue">{questionSummary.label}</span>
        </div>
        <div className="q-card-body">
            <div className="card-content">
                <RichTextTranslation
                    value={getRichTextFromQuestionTexts(
                        questionSummary,
                        languages
                    )}
                />
            </div>
        </div>
    </div>
);

const ShowGroupQuestion: React.SFC<ShowGroupQuestionProps> = ({
    questionSummary,
    languages
}: ShowGroupQuestionProps) => (
    <div className="option-box question-card ">
        <div className="q-card-header ">
            <span className="question-image">
                <img
                    src={
                        QuestionTypesMap[
                            questionSummary.type || QTYPES.SINGLE_CHOICE
                        ].image
                    }
                />
            </span>
            <span className="badge badge--blue">{questionSummary.label}</span>
        </div>
        <div className="q-card-body group">
            <div className="card-content">
                <ShowQuestion
                    questionSummaries={questionSummary.childrenSummaries || []}
                    languages={languages}
                />
            </div>
        </div>
    </div>
);
